import type {ChangeEvent, ReactElement} from 'react';
import {Text, TextSize} from '@Components/text';
import type {SliderTextInputProps} from '../../slider-control.types';
import {parseAndClamp} from '../../slider-control.utils';
import styles from '../../slider-control.module.scss';

export function SliderTextInput({value, unit, min, max, step, centerAlign, isActive, propertyName, onActivate, onDeactivate, onChange}: SliderTextInputProps): ReactElement {
  const isMixed = value === 'mixed';
  const inputType = isMixed ? 'text' : 'number';
  const displayValue = isMixed ? window.i18next.t('pmwjs_mixed') : String(value);

  function handleFocus(): void {
    onActivate();
  }

  function handleBlur(): void {
    onDeactivate();
  }

  function handleChange(e: ChangeEvent<HTMLInputElement>): void {
    const parsed = parseAndClamp(e.target.value, min, max);
    onChange(parsed);
  }

  return (
    <div className={`${styles.inputContainer} ${isActive ? styles.inputContainerActive : ''}`}>
      <input
        aria-label={window.i18next.t('pmwjs_property_slider', {property: propertyName})}
        className={`${styles.textInput} ${centerAlign ? styles.textInputCenter : ''} ${isMixed ? styles.textInputMixed : ''}`}
        max={max}
        min={min}
        onBlur={handleBlur}
        onChange={handleChange}
        onFocus={handleFocus}
        step={step}
        type={inputType}
        value={displayValue}
      />
      {unit ? <Text val={unit} size={TextSize.SM} className={`${styles.unitLabel} ${isMixed ? styles.unitHidden : ''}`} /> : null}
    </div>
  );
}
